// extracted by mini-css-extract-plugin
export default {"card":"Card_card__vgrcq","price":"Card_price__px1au","img_holder":"Card_img_holder__8zn5-","img":"Card_img__Q+0D-"};